import React, { useState, useEffect, useContext } from "react";
import { Form, Input, Button, Alert, message, Typography } from "antd";
import { UserOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import LoginService from "services/LoginService";
import { useHistory } from "react-router";
import { SecurityContext } from "context/SecurityContextProvider";
import { VersionApiColaborador } from "../../enum/VersionApiColaborador";

const { Text } = Typography;

const subdominio = window.location.host.split(".")[0];
const SEPARADOR_DOMINIO = "__";
const parametros = window.location.search;
const buscadorParametros = new URLSearchParams(parametros);

const LoginEmpresaPage = () => {
	const [autenticacionFallida, setAutenticacionFallida] = useState(false);
	const [mensajeError, setMensajeError] = useState("");
	const [loading, setLoading] = useState(false);
	const [urlFondo, setUrlFondo] = useState("");
	const [urlLogotipo, setUrlLogotipo] = useState("");
	const [requiereDosFactores, setRequiereDosFactores] = useState(false);
	const [usuarioIdDosFactores, setUsuarioIdDosFactores] = useState(null);
	const [correoMascarado, setCorreoMascarado] = useState(null);
	const [loadingReenviar, setLoadingReenviar] = useState(false);
	const history = useHistory();

	const { getVersionApiColaborador, getUsuarioAutenticado, setSesionUsuario } = useContext(SecurityContext);

	useEffect(() => {
		const fetchData = async () => {
			const datos = await LoginService.cargarDatosIniciales(subdominio);
			setUrlFondo(datos.urlImagenFondo);
			setUrlLogotipo(datos.urlImagenLogotipo);
			const sesionExpirada = localStorage.getItem("sesionExpirada");
			if (sesionExpirada === "si") {
				message.info("Su sesión ha expirado.", 8);
				localStorage.removeItem("sesionExpirada");
			}
		};
		fetchData();
	}, []);

	const onClickBtnIniciarSesion = async (formulario) => {
		setAutenticacionFallida(false);
		setLoading(true);
		const documentoTrim = formulario.usuario.replace(/\s+/g, "");
		try {
			const respuesta = await LoginService.autenticar(
				(formulario.usuario = subdominio + SEPARADOR_DOMINIO + documentoTrim),
				formulario.clave
			);

			if (respuesta.estado === "ok" && respuesta.dobleFactorAutenticacion) {
				setLoading(false);
				setRequiereDosFactores(true);
				setUsuarioIdDosFactores(respuesta.usuarioId);
				setCorreoMascarado(respuesta.correoMascarado || null);
				return;
			}

			if (respuesta.estado === "ok") {
				setAutenticacionFallida(false);
				procesarRedireccion(respuesta);
			} else if (respuesta.error === "auth-1") {
				setLoading(false);
				setAutenticacionFallida(true);
				setMensajeError("Usuario y/o clave son incorrectos");
			} else if (respuesta.error === "auth-2") {
				setLoading(false);
				setAutenticacionFallida(true);
				setMensajeError("No tiene acceso a la plataforma. Revise sus credenciales.");
			}
		} catch (error) {
			if (error.response && error.response.data.mensaje) {
				setAutenticacionFallida(true);
				setMensajeError(error.response.data.mensaje);
			}
			setLoading(false);
		}
	};

	const onClickLinkOlvideClave = () => {
		history.push("/actualizarClave");
	};

	const procesarRedireccion = (respuesta) => {
		setSesionUsuario(respuesta);
		const sesionUrl = buscadorParametros.get("sesionUrl");
		const sesionTab = buscadorParametros.get("sesionTab");
		if (sesionUrl) {
			history.push(sesionUrl + (sesionTab ? "?sesionTab=" + sesionTab : ""));
		} else if (getVersionApiColaborador() === VersionApiColaborador.v1) {
			history.push("/bandejaEntrada");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v2 &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado !== "ONBOARDING"
		) {
			history.push("/mis-documentos");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v3 &&
			getUsuarioAutenticado().cambiarClaveAlIniciarSesion &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado !== "ONBOARDING"
		) {
			history.push("/cambiarClave");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v3 &&
			!getUsuarioAutenticado().cambiarClaveAlIniciarSesion &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado !== "ONBOARDING" &&
			getUsuarioAutenticado().versionPortalColaborador == "v1"
		) {
			history.push("/v3/mis-pendientes");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v3 &&
			!getUsuarioAutenticado().cambiarClaveAlIniciarSesion &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado !== "ONBOARDING" &&
			getUsuarioAutenticado().versionPortalColaborador == "v2"
		) {
			history.push("/v3/mi-portal");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v2 &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado === "ONBOARDING"
		) {
			history.push("/onboarding");
		} else if (
			getVersionApiColaborador() === VersionApiColaborador.v3 &&
			getUsuarioAutenticado().empresaSeleccionada.colaborador.estado === "ONBOARDING"
		) {
			history.push("/onboarding");
		} else {
			history.push("/bandejaEntrada");
		}
	};

	const onSubmitCodigoVerificacion = async (formulario) => {
		setAutenticacionFallida(false);
		setLoading(true);
		try {
			const respuesta = await LoginService.verificarCodigoDosFactores(
				usuarioIdDosFactores,
				formulario.codigo.trim().toUpperCase()
			);
			if (respuesta.estado === "ok") {
				procesarRedireccion(respuesta);
			} else {
				setLoading(false);
				setAutenticacionFallida(true);
				setMensajeError(respuesta.mensaje || "Código incorrecto. Intente nuevamente.");
			}
		} catch (error) {
			setAutenticacionFallida(true);
			setMensajeError(
				error.response?.data?.mensaje || "Código incorrecto o expirado. Intente nuevamente."
			);
			setLoading(false);
		}
	};

	const onClickReenviarCodigo = async () => {
		setLoadingReenviar(true);
		setAutenticacionFallida(false);
		try {
			const respuesta = await LoginService.reenviarCodigoDosFactores(usuarioIdDosFactores);
			if (respuesta.correoMascarado) setCorreoMascarado(respuesta.correoMascarado);
			message.success("Código reenviado a tu correo.", 5);
		} catch {
			message.error("No se pudo reenviar el código. Intente más tarde.", 5);
		} finally {
			setLoadingReenviar(false);
		}
	};

	if (requiereDosFactores) {
		return (
			<div className="container-login">
				<div className="container-login--fondo" style={{ backgroundImage: "url(" + urlFondo + ")" }} />
				<div className="container-login--wrapper">
					<img className="container-login--wrapper__logotipo" src={urlLogotipo} width="180px" alt="Logotipo" />

					<div className="container-login--wrapper__titulo">
						<span>Verificación en dos pasos</span>
					</div>

					<div style={{ marginBottom: 20, textAlign: "center" }}>
						<MailOutlined style={{ fontSize: 32, color: "#1890ff", marginBottom: 8 }} />
						<br />
						<Text type="secondary">
							{correoMascarado
								? <>Hemos enviado un código de verificación a <strong>{correoMascarado}</strong></>
								: "Hemos enviado un código de verificación a tu correo registrado."}
						</Text>
					</div>

					{autenticacionFallida && (
						<Alert style={{ marginBottom: 16 }} message={mensajeError} type="error" showIcon />
					)}

					<Form name="frmVerificacion" onFinish={onSubmitCodigoVerificacion}>
						<Form.Item
							name="codigo"
							rules={[{ required: true, message: "Por favor, ingresa el código de verificación." }]}
						>
							<Input
								size="large"
								maxLength={10}
								placeholder="Código de verificación"
								autoFocus
								style={{ letterSpacing: 4, textAlign: "center", textTransform: "uppercase" }}
							/>
						</Form.Item>

						<Form.Item>
							<Button
								type="primary"
								htmlType="submit"
								size="large"
								loading={loading}
								style={{ width: "100%" }}
							>
								Verificar
							</Button>
						</Form.Item>
					</Form>

					<div style={{ textAlign: "center", marginTop: 8 }}>
						<Text type="secondary">¿No recibiste el código? </Text>
						<Button
							type="link"
							size="small"
							loading={loadingReenviar}
							onClick={onClickReenviarCodigo}
							style={{ padding: 0 }}
						>
							Reenviar código
						</Button>
					</div>

					<div style={{ textAlign: "center", marginTop: 16 }}>
						<Button
							type="link"
							size="small"
							onClick={() => {
								setRequiereDosFactores(false);
								setUsuarioIdDosFactores(null);
								setAutenticacionFallida(false);
							}}
						>
							Volver al inicio de sesión
						</Button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="container-login">
			<div className="container-login--fondo" style={{ backgroundImage: "url(" + urlFondo + ")" }} />

			<div className="container-login--wrapper">
				<img className="container-login--wrapper__logotipo" src={urlLogotipo} width="180px" alt="Logotipo" />

				<div className="container-login--wrapper__titulo">
					<span>Iniciar Sesión</span>
				</div>

				{autenticacionFallida && (
					<Alert
						style={{
							marginBottom: 24,
						}}
						message={mensajeError}
						type="error"
						showIcon
					/>
				)}

				<Form name="frmLogin" className="" onFinish={onClickBtnIniciarSesion}>
					<Form.Item
						name="usuario"
						rules={[
							{
								required: true,
								message: "Por favor, ingresa tu número de documento de identidad.",
							},
						]}
					>
						<Input
							size="large"
							maxLength={32}
							prefix={<UserOutlined className="site-form-item-icon" />}
							placeholder="Número de documento de identidad"
						/>
					</Form.Item>
					<Form.Item
						name="clave"
						rules={[
							{
								required: true,
								message: "Por favor, ingresa tu clave.",
							},
						]}
					>
						<Input.Password
							size="large"
							prefix={<LockOutlined className="site-form-item-icon" />}
							type="password"
							placeholder="Clave"
						/>
					</Form.Item>
					<Form.Item>
						<a href="#/" style={{ float: "right" }} onClick={onClickLinkOlvideClave}>
							¿Olvidaste tu clave?
						</a>
					</Form.Item>

					<Form.Item>
						<Button
							type="primary"
							htmlType="submit"
							size="large"
							loading={loading}
							style={{ width: "100%" }}
						>
							Iniciar Sesión
						</Button>
					</Form.Item>
				</Form>
			</div>
		</div>
	);
};

export default LoginEmpresaPage;
